<template>
    <div>
        <GChart
            type="BubbleChart"
            :settings="{packages: ['corechart'], language: 'pt-br'}"
            :data="chartDataFinal"
            :options="chartOptions"
        />
    </div>
</template>

<script>
export default {
    props: ['chartData', 'currency'],
    data() {
        return {
            chartOptions: {
                fontName: 'Muli',
                height: 400,
                hAxis: {
                    title: this.__('reports.Number of Bets')
                },
                vAxis: {
                    title: this.__('reports.Profit/Loss'),
                    format: 'decimal',
                    textStyle: {
                        fontSize: 12
                    }
                },
                chartArea: {
                    top: 10,
                    height: 300
                },
                legend: {
                    textStyle: {
                        fontSize: 12,
                    }
                },
            }
        }
    },
    computed: {
        chartDataFinal() {
            return this.chartData
        }
    },
}
</script>

<style scoped>

</style>
